import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import {Button, FormGroup, Input, Label, Row, Col} from 'reactstrap';
import {Tabela} from "../../comum/components/Tabela";
import {ModalForm} from "../../comum/components/ModalForm";
import PropTypes from 'prop-types';
import TabelaFluxoStore from "../stores/TabelaFluxoStore";
import {toast} from "react-toastify";
import {createSelectOptions} from "../../../utils/formatar";
import Select from "react-select";
import {Validacao} from "./Validacao";
import {Link} from "react-router-dom";
import FontAwesome from 'react-fontawesome';
import _ from "lodash";
import EmpregadoService from "../../../services/EmpregadoService";

@inject("store")
@observer
export class TabelaFluxo extends Component {
    static propTypes = {
        nomeFluxo: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.modalStore     = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.tabelaStore    = this.props.store.tabelaStore;
        this.formStore      = this.props.store.formStore;
        this.loginStore     = this.props.store.loginStore;
        this.appStore       = this.props.store.appStore;

        this.toggleDelegarModal  = this.toggleDelegarModal.bind(this);
        this.toggleAprovarModal  = this.toggleAprovarModal.bind(this);
        this.toggleCancelarModal = this.toggleCancelarModal.bind(this);
        this.delegarSelecionados = this.delegarSelecionados.bind(this);
        this.aprovarSelecionados = this.aprovarSelecionados.bind(this);

        this.controller = new TabelaFluxoStore(this.loginStore);

        this.state = {
            empregadoService: new EmpregadoService()
        }
    }

    componentDidMount() {
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.formStore.setSubmitted(false);
        this.formStore.setSubmitMensagemErro("");
    }

    /* qual modal renderizar */
    modalForm(){
        if (this.modalStore.exibirModal.aberto) {
            switch (this.modalStore.exibirModal.tipo) {
                case 'delegar':
                    return (
                        <ModalForm
                            corpo={this.modalDelegar()}
                            cabecalho={this.props.nomeFluxo +": Transferir tarefa"}
                            botoes={this.botoesModalDelegar()}  />
                    );
                case 'aprovar':
                    return (
                        <ModalForm
                            corpo={this.modalAprovar()}
                            cabecalho={this.props.nomeFluxo +": Aprovar em lote"}
                            botoes={this.botoesModalAprovar()}  />
                    );
                case 'aprovarTimesheet':
                    return (
                        <ModalForm
                            corpo={this.modalAprovar()}
                            cabecalho={this.props.nomeFluxo +": Aprovar em lote"}
                            botoes={this.botoesModalAprovarTimesheet()}  />
                    );
                case 'enviarTimesheet':
                    return (
                        <ModalForm
                            corpo={this.modalAprovar()}
                            cabecalho={this.props.nomeFluxo +": Enviar em lote"}
                            botoes={this.botoesModalEnviarTimesheet()}  />
                    );
                case 'cancelar':
                    return (
                        <ModalForm
                            corpo={this.modalCancelar()}
                            cabecalho={this.props.nomeFluxo +": Cancelar"}
                            botoes={this.botoesModalCancelar()}
                        />
                    );
            }
        }
    }

    modalDelegar = () => {
        return(
            <FormGroup>
                <Label>Transferir para:</Label>
                <Select simpleValue cacheAsyncResults={false} value={this.controller.usuarioDelegadoLogin}
                        onChange={(value) => this.controller.setUsuarioDelegado(value)}
                        autoload={false}
                        searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                        asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)}
                />
                {<Validacao id="usuarioDelegado" valor={this.controller.usuarioDelegadoLogin} tipo={["isRequired"]}/>}
            </FormGroup>            
        )
    };

    modalAprovar = () => {
        const observacoes =
            <FormGroup>
                <Label>Observações</Label>
                <Input type="textarea" maxLength={1024} value={this.controller.observacoes}
                       onChange={(event) => this.controller.setObservacoes(event.target.value)}/>
            </FormGroup>;
        const aprovadoresExtraForm = [];
        if(this.controller.matriculaAprovadoresExtra) {
            for(let i=0; i<this.controller.matriculaAprovadoresExtra.length; i++) {
                aprovadoresExtraForm.push(
                    <Row key={i}>
                        <Col xs={12}>
                            {this.controller.matriculaAprovadoresExtra[i] !== null &&
                            <FormGroup>
                                <div className="multiple-selects">
                                    <Select className="multiple-selects-input"
                                            options={this.controller.todosAprovadores}
                                            value={this.controller.matriculaAprovadoresExtra[i]}
                                            onChange={(value, option) => {
                                                this.controller.setMatriculaAprovadoresExtra(value, option, i)
                                            }}
                                            asyncOptions={ (input, callback) => {this.controller.filtrarAprovadoresExtra(input,callback);}}
                                            multi={false}
                                            placeholder="Selecione uma opção..."
                                            noResultsText="Nenhum resultado encontrado"
                                    />
                                    <div className="multiple-selects-buttons">
                                        {(i > this.controller.posicaoPrimeiroAprovadorExtra || this.controller.quantidadeAprovadoresExtraMostrados > 1) &&
                                        <a onClick={() => this.controller.removerAprovadorExtra(i)} title="Remover"><FontAwesome name="minus-circle"/></a>
                                        }
                                        <a onClick={() => this.controller.adicionarAprovadorExtra(i)}
                                           title="Adicionar"><FontAwesome name="plus-circle"/></a>
                                    </div>
                                </div>
                            </FormGroup>
                            }
                        </Col>
                    </Row>
                )
            }
            aprovadoresExtraForm.push(
                <Validacao id="aprovadoresUnicos" valor={this.controller.apenasMatriculaAprovadoresExtraValidos} tipo={["isArrayUnique"]}/>
            )

        }
        return(
            <div>
                {this.controller.idSolicitacaoBloqueandoAprovacaoLote
                    ?
                    <p>{"Não é possível aprovar em lote a solicitação com identificador "+this.controller.idSolicitacaoBloqueandoAprovacaoLote}</p>
                    :
                    this.controller.temTarefaQuePodeInserirAprovadorExtra
                        ?
                        <div>
                            <label>Aprovadores extra (tarefas: {this.controller.tarefasComAprovadoresExtra})</label>
                            {aprovadoresExtraForm}
                            {observacoes}
                        </div>
                        :
                        <div>
                            {observacoes}
                        </div>
                    }
            </div>
        )
    };

    modalCancelar = () => {
        return(
            <div>
                <p>Tem certeza que deseja cancelar as solicitações selecionadas?</p>
                <FormGroup>
                    <Label>Justificativa <sup>*</sup></Label>
                    <Input type="textarea" value={this.controller.observacoes}
                           onChange={(event) => this.controller.setObservacoes(event.target.value)}/>
                </FormGroup>
                <Validacao id="observacaoCancelamento" valor={this.controller.observacoes} tipo={["isRequired"]}/>
            </div>
        )
    };

    botoesModalAprovar(){
        return (<div>
            {!this.controller.idSolicitacaoBloqueandoAprovacaoLote &&
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.aprovarSelecionados(this.props.listaItens)}>Confirmar</Button>
            }
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    botoesModalAprovarTimesheet(){
        return (<div>
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.aprovarTimesheetSelecionados(this.props.listaItens)}>Confirmar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    botoesModalEnviarTimesheet(){
        return (<div>
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.enviarTimesheetSelecionados(this.props.listaItens)}>Confirmar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    botoesModalDelegar(){
        return (<div>

            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.delegarSelecionados(this.props.listaItens)}>Confirmar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    botoesModalCancelar(){
        return (<div>
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.cancelarSelecionados(this.props.listaItens)}>Confirmar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    aprovarSelecionados = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.aprovarSelecionados(...props), 'Solicitações aprovadas', ...args);

    aprovarTimesheetSelecionados = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.aprovarTimesheeetSelecionados(...props), 'Horas trabalhadas aprovadas', ...args);

    enviarTimesheetSelecionados = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.enviarTimesheeetSelecionados(...props), 'Horas trabalhadas enviadas', ...args);

    delegarSelecionados = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.delegarSelecionados(...props), 'Solicitações transferidas', ...args);

    cancelarSelecionados = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.cancelarSelecionados(...props), 'Solicitações canceladas', ...args);

    migrarSelecionados = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.migrarSelecionados(...props), 'Solicitações migradas com sucesso', ...args);

    //RHFPP-2370-PocTimesheet - Tratamento para separar o envio do lote  
    tramitarEmToleETratarResultado = (funcaoTramitacao, mensagemSucesso, ...args) => {
        this.modalStore.setSubmitted(true);
        this.modalStore.setSubmitMensagemErro("");
        if (this.validacaoStore.isValidForm && !this.modalStore.loading) {
            this.modalStore.loading = true;
            funcaoTramitacao(...args, this.props.fluxoNovo).then(response => {
                this.tabelaStore.onSelectAll(false, this.props.listaItens, this.props.keyField);
                if(this.props.controller && this.props.controller.carregarLista){
                    this.props.controller.carregarLista();
                }
                else if(this.props.reload){
                    this.props.reload();
                }
                this.modalStore.toggleModal();
                this.controller.cleanSucessList();
                toast.success(mensagemSucesso);
            }).catch(error => {
                this.modalStore.setSubmitMensagemErro(error.response ? error.response.data.message : error);
                this.modalStore.loading = false;
                //this.controller.cleanErrorList();
            });
        }
    };

    toggleDelegarModal(){
        this.controller.usuarioDelegadoLogin = "";
        this.modalStore.toggleModal('delegar');
    }

    toggleAprovarModal(){
        //this.controller.carregarAprovadores();
        this.controller.observacoes = "";
        this.controller.verificarAprovacaoEmLote(this.props.listaItens);
        this.modalStore.toggleModal('aprovar');
    }

    toggleAprovarTimesheetModal = () =>{
        //this.controller.carregarAprovadores();
        this.controller.observacoes = "";
        this.modalStore.toggleModal('aprovarTimesheet');
    }

    toggleEnviarTimesheetModal = () =>{
        //this.controller.carregarAprovadores();
        this.controller.observacoes = "";
        this.modalStore.toggleModal('enviarTimesheet');
    }

    toggleCancelarModal = () =>{
        this.modalStore.toggleModal('cancelar');
    }

    visualizarAcao = (row, itemAcao, i) =>{
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        
        let path = null;
        if(row.definicaoTarefaId === "HT_SolicitacaoContratacao" && row.nomeFluxo === "GloboMOTSolicitacaoMOT") {
            path = "/ajuste-solicitacao/" +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_SolicitacaoContratacao" && row.nomeFluxo === "SolicitacaoContratacao") {
            path = "/ajuste-solicitacao-contrato/" +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_AjusteSolicitacao" && row.nomeFluxo === "SolicitacaoProrrogacao") {
            path = "/ajuste-prorrogacao/" +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_AvaliarHorasExtrasGestor") {
            path = (row.path && row.path !== null ? row.path : "/detalhamento-horas-trabalhadas/tarefa/") +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_AjustarHorasExtrasETT") {
            path = (row.path && row.path !== null ? row.path : "/ajuste-horas-trabalhadas/tarefa/") +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_LancarHorasExtrasETT") {
            path = (row.path && row.path !== null ? row.path : "/envio-horas-trabalhadas/tarefa/") +_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTPagamento") {
            path = "/envio-pagamento/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSubstituicao") {
            path = "/detalhamento-substituicao/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSolicitacaoProrrogacao") {
            path = "/detalhamento-prorrogacao/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSolicitacaoEtt") {
            path = "/detalhamento-solicitacao-ett/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSolicitacaoTerminoAntecipado") {
            path = "/detalhamento-termino-antecipado/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "SolicitacaoContratacao") {//versao novo fluxo
            path = "/solicitacao-contrato/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "SolicitacaoEtt") {//versao novo fluxo
            path = "/contratacao/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "SolicitacaoProrrogacao") {//versao novo fluxo
            path = "/prorrogacao-contrato/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "SolicitacaoTerminoAntecipado") {//versao novo fluxo
            path = "/detalhamento-termino-antecipado/tarefa/"+_.get(row,itemAcao.parametro)
        } else {
            path = "/detalhamento/tarefa/"+_.get(row,itemAcao.parametro)
        }
        return <Link key={i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} to={path}><FontAwesome name={itemAcao.icone}/></Link>
    }

    trClassName(row, rowIndex) {
        if(row.idSolicitacaoBpm === undefined) return "";
        if (row.idSolicitacaoBpm === null) return "table-row-error";
        else return "";
    }

    visualizarControle = (row, itemAcao, i) =>{
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        return <Link key={i} className={"btn btn-secondary "+ buttonType + itemAcao.cor} title={itemAcao.label} to={"/detalhamento/solicitacao/"+_.get(row,itemAcao.parametro)}><FontAwesome name={itemAcao.icone}/></Link>
    }

    visualizarHistoricoContratos = (row, itemAcao, i) =>{
        if (row.sistemaOrigem === 'SGTMOT'){
            const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
            return <Link key={i} className={"btn btn-secondary "+ buttonType + itemAcao.cor} title={itemAcao.label} to={"/detalhamento/solicitacao/"+_.get(row,itemAcao.parametro)}><FontAwesome name={itemAcao.icone}/></Link>
        }
    }

    examinarFalha = (row, itemAcao, i) => {
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        const estadoTarefa = _.get(row, "estadoTarefa");
        let icone, cor, t;
        switch (estadoTarefa) {
//            case 'ALERTED': icone = 'exclamation-triangle'; cor = 'text-warning'; t = 'Recuperação Necessária'; break;
//            case 'ERRORED': icone = 'exclamation-circle'; cor = 'text-danger'; t = 'Com falha'; break;
            // case 'EXPIRED': break; //???
            // case 'INFO_REQUESTED': break; //???
            // case 'OUTCOME_UPDATED': break; // Resultado Atualizado
//            case 'SUSPENDED': icone = 'clock-o'; cor = 'text-info'; t = 'Suspenso'; break;
//            case 'WITHDRAWN': icone = 'minus-circle'; cor = 'text-danger'; t = 'Abortado'; break;
            // COMPLETED e STALE nunca aparecem
            // default: icone = 'check-circle'; cor = 'text-success'; t = 'Concluído'; break;
            default: return null; // case 'ASSIGNED': sem botão; Em Execução
        }
        function askRecuperarFluxo(event, id) {
            event.stopPropagation();
            /*Popup.create({
                title: "Recuperar?",
                content: "Recuperar fluxo?\n/detalhamento/falha?id=" + id,
                buttons: {
                    left: ['cancel'],
                    right: [{
                        text: 'Recuperar',
                        action: popup => { recuperarFluxo(); popup.close(); }
                    }],
                },
            });*/
        }
        function recuperarFluxo() {
            console.log('RECUPERAR!'); //TODO
        }
        return <Button key={i + '_falha'} className={"btn btn-secondary " + buttonType + cor}
            title={t + itemAcao.label}
            onClick={event => askRecuperarFluxo(event, _.get(row, itemAcao.parametro))}
        ><FontAwesome name={icone} /></Button>
    }

    visualizarAndamento = (row, itemAcao, i) => {
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        const parametros = _.get(row,itemAcao.parametro);
        const idBpm = _.get(row,"idSolicitacaoBpm");
        const Bpm = '?id=' + (idBpm || '');
        const ids = parametros.split("/");
        const fluxoNovo = _.get(row,"fluxoNovo") === true;
        const idFluxo = _.get(row,"idFluxo");

        let path = "/detalhamento/solicitacao/";
        if(ids.length === 3) {
            const tipoAlteracao = ids[2];
            if(tipoAlteracao.includes("SB")) {
                path = "/detalhamento/substituicao/";
            } else if(tipoAlteracao.includes("PR")) {
                path = "/detalhamento/prorrogacao/";
            } else if(tipoAlteracao.includes("TA")) {
                path = "/detalhamento/termino-antecipado/";
            }
        }
        const pathCompleto = path + parametros + Bpm + (fluxoNovo ? "&idFluxo=" + idFluxo : "");
        return (
            <Link key={i} className={"btn btn-secondary " + buttonType + itemAcao.cor}
                  title={itemAcao.label}
                  to={pathCompleto}>
                <FontAwesome name={itemAcao.icone}/>
            </Link>
        )
    }

    botoesTabelaVigentes = (row) => {
        let acoesItens = [];
        if( (this.loginStore.isPerfilAdministradorLogado || (row.isGestorSolicitacao) || (row.isSolicitanteSolicitacao)) || (this.loginStore.isSolicitanteMotGestor(row.idGestorSolicitante) && (this.loginStore.checkPermission("solicitar-mot")))) {
            acoesItens =  ["visualizarControle", "clonar", "anteciparTermino", "prorrogar", "migrarProduto"];
        } else if(this.loginStore.isDelegouUsuarioLogado(row.idSolicitante)){
            acoesItens =  ["visualizarControle", "anteciparTermino", "prorrogar", "migrarProduto"];
        }else if(this.loginStore.isPerfilEttLogado) {
            acoesItens =  ["visualizarControle"]
        } else {
            acoesItens =  ["visualizarControle"];
        }

        acoesItens = this.transformaAcoes(acoesItens);

        return acoesItens;
    };

    transformaAcoes = (acoesItensList) => {
        const acoesItens = [];
        for (let i = 0; i < acoesItensList.length; i++) {
            switch (acoesItensList[i]) {
                case 'visualizar':
                    acoesItens.push({
                        tipo: "visualizar",
                        label: "Visualizar",
                        icone: "search-plus",
                        cor: "text-info",
                        parametro: this.props.parametroVisualizar,
                        acao: this.visualizarAcao
                    });
                    break;
                case 'clonar':
                    acoesItens.push({
                        tipo: "clonar",
                        label: "Clonar",
                        icone: "clone",
                        parametro: this.props.parametroClonar,
                        acao: "/clonar-solicitacao-contratacao"
                    });
                    break;
                case 'visualizarControle':
                    acoesItens.push({
                        tipo: "visualizarControle",
                        label: "Visualizar",
                        icone: "search-plus",
                        cor: "text-info",
                        parametro: this.props.parametroVisualizar,
                        acao: this.visualizarControle
                    });
                    break;
                case 'visualizarAndamento':
                    acoesItens.push({
                        tipo: "visualizarAndamento",
                        label: "Visualizar",
                        icone: "search-plus",
                        cor: "text-info",
                        parametro: this.props.parametroVisualizar,
                        acao: this.visualizarAndamento
                    });
                    break;
                case 'visualizarHistoricoContratos':
                        acoesItens.push({
                            tipo: "visualizarHistoricoContratos",
                            label: "Visualizar",
                            icone: "search-plus",
                            cor: "text-info",
                            parametro: this.props.parametroVisualizar,
                            acao: this.visualizarHistoricoContratos
                        });
                        break;
                    case 'anteciparTermino':
                    acoesItens.push({
                        tipo: "anteciparTermino",
                        label: "Antecipar término",
                        icone: "history",
                        parametros: ['solicitacaoId', 'solicitacaoEttId'],
                        acao: "/solicitacao-termino-antecipado"
                    });
                    break;
                case 'prorrogar':
                    acoesItens.push({
                        tipo: "prorrogar",
                        label: "Prorrogar",
                        icone: "history",
                        flip: "horizontal",
                        parametros: ['solicitacaoId', 'solicitacaoEttId'],
                        acao: "/solicitacao-prorrogacao"
                    });
                    break;
                case 'substituir':
                    acoesItens.push({
                        tipo: "substituir",
                        label: "Substituir",
                        icone: "exchange",
                        parametros: ['solicitacaoId', 'solicitacaoEttId'],
                        acao: "/solicitacao-substituicao"
                    });
                    break;
                case 'migrarProduto':
                    acoesItens.push({
                        tipo: "migrar",
                        label: "Migrar para projeto/centro de resultado/finalidade",
                        icone: "share-square-o",
                        parametros: ['solicitacaoId', 'solicitacaoEttId'],
                        acao: "/solicitacao-migracao"
                    });
                    break;
                case 'examinarFalha':
                    acoesItens.push({
                        tipo: "examinarFalha",
                        label: "\nExaminar...",
                        parametro: this.props.parametroFalha,
                        acao: this.examinarFalha
                    });
                    break;
                default:
                    if(this.props.acoesItens[i] && typeof this.props.acoesItens[i] === "object") {
                        acoesItens.push(this.props.acoesItens[i])
                    }
            }
        }

        return acoesItens;
    };

    cardClick = (row, itemAcao, i, acoesItens) => {
        const acaoItem = _.find(acoesItens, {label: "Visualizar"});

        if(acaoItem) {
            return acaoItem.acao(row, itemAcao, i);
        }
    };

    render() {
        /* Especificar Botões no topo da TabelaStore (Se houverem) */
        const acoesMultiplas = [];
        if(this.props.acoesMultiplas) {
            for (let i = 0; i < this.props.acoesMultiplas.length; i++) {
                switch (this.props.acoesMultiplas[i]) {
                    case 'delegar':
                        acoesMultiplas.push({
                            label: "Delegar",
                            icone: "mail-forward",
                            acao: this.toggleDelegarModal
                        });
                        break;
                    case 'migrarBpm':
                        acoesMultiplas.push({
                            label: "Migrar do BPM",
                            icone: "thumbs-up",
                            acao: () => this.migrarSelecionados(this.props.listaItens)
                        });
                        break;
                    case 'aprovar':
                        acoesMultiplas.push({
                            label: "Aprovar",
                            icone: "thumbs-up",
                            acao: this.toggleAprovarModal
                        });
                        break;
                    case 'aprovarTimesheet':
                        acoesMultiplas.push({
                            label: "Aprovar",
                            icone: "thumbs-up",
                            acao: this.toggleAprovarTimesheetModal
                        });
                        break;
                    case 'enviarTimesheet':
                        acoesMultiplas.push({
                            label: "Enviar",
                            icone: "thumbs-up",
                            acao: this.toggleEnviarTimesheetModal
                        });
                        break;
                    case 'cancelar':
                        acoesMultiplas.push({
                            label: "Cancelar",
                            icone: "trash",
                            acao: this.toggleCancelarModal
                        });
                        break;
                }
            }
        }

        /* Especificar botões nos itens da tabela (Se houverem) */
        let acoesItens = [];

        if(this.props.acoesItens === "botoesContratacoesVigentes") {
            acoesItens = this.botoesTabelaVigentes;
        } else if(this.props.acoesItens) {
            acoesItens = this.transformaAcoes(this.props.acoesItens);
        }

        return (
            <div>
                <Tabela
                    keyField={this.props.keyField}
                    useCardsMobile={true}
                    habilitarSelecaoMultipla={true}
                    listaItens={this.props.listaItens}
                    colunaId={this.props.colunaId}
                    colunaSolicitacaoId={this.props.colunaSolicitacaoId}
                    colunas={this.props.colunas}
                    acoesMultiplas={acoesMultiplas}
                    temBusca={this.props.temBusca}
                    acoesItens={acoesItens}
                    tituloMobile={this.props.tituloMobile}
                    conteudoMobile={this.props.conteudoMobile}
                    extraMobile={this.props.extraMobile}
                    onChange={this.props.onChange}
                    onCardClick={(row, itemAcao, i) => this.cardClick(row, itemAcao, i, acoesItens)}
                    loading={this.props.loading}
                    setTableRef={(...props) => this.controller.setTableRef(...props)}
                    colunaOrdenacaoPadrao={this.props.colunaOrdenacaoPadrao}
                    tipoOrdenacaoPadrao={this.props.tipoOrdenacaoPadrao}
                    recarregar={this.props.recarregar}
                    upload={this.props.upload}
                    botoesDinamicos={this.props.acoesItens === "botoesContratacoesVigentes"}
                    mobileFilter={this.props.mobileFilter}
                    trClassName={this.trClassName}
                />
                {this.modalForm()}
            </div>

        );
    }
}